// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"904":"f43cba29","923":"bff10151"}[chunkId] + ".chunk.js";
};